import { render, staticRenderFns } from "./RefreshEmpty.vue?vue&type=template&id=be63bd1a&scoped=true"
import script from "./RefreshEmpty.vue?vue&type=script&lang=js"
export * from "./RefreshEmpty.vue?vue&type=script&lang=js"
import style0 from "./RefreshEmpty.vue?vue&type=style&index=0&id=be63bd1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be63bd1a",
  null
  
)

export default component.exports